<script setup>
// "×" dentro do filtro de seleção única do relatório. O multiselect deixava
// desmarcar clicando de novo na opção escolhida, mas nada na tela dizia isso:
// quem filtrava uma caixa não conseguia voltar para "todas".
defineEmits(['clear']);
</script>

<template>
  <button
    v-tooltip="$t('REPORT.FILTER_CLEAR')"
    type="button"
    class="absolute inset-y-0 z-10 flex items-center justify-center my-auto rounded right-8 size-5 text-n-slate-11 hover:text-n-slate-12"
    :aria-label="$t('REPORT.FILTER_CLEAR')"
    @mousedown.prevent.stop="$emit('clear')"
  >
    <i class="block shrink-0 size-3.5 min-w-3.5 i-lucide-x" />
  </button>
</template>
